<template>
  <ChartWrapper v-bind="$props" :is-data-empty="isDataEmpty" :context="context" />
</template>

<script>
import ChartWrapper from '@/modules/core/legacy/charts/am5/base/components/ChartWrapper.vue';
import { createChartContext } from '@/modules/core/legacy/charts/am5/base/composables/createChartContext';
import { isEmpty, isNil } from 'lodash';
import { useComboChart } from '@/modules/core/legacy/charts/am5/combo/composables/useComboChart';
import { WidgetEvents } from '@/modules/core/legacy/charts/am5/charts.constants';
import { WidgetConfig } from '@/modules/ta/legacy/widget/widget.constants';
import { BasePropsMixin } from '@/modules/core/legacy/charts/am5/base/mixins/BasePropsMixin';

export default {
  name: 'ComboChart',
  mixins: [BasePropsMixin],
  components: {
    ChartWrapper,
  },
  setup(props, componentContext) {
    const context = createChartContext(props.config);
    const { refresh, onBind, onFrameEnded } = context();
    const { initComboChart } = useComboChart(context);

    onBind(() => {
      initComboChart();
    });

    onFrameEnded(() => {
      componentContext.emit(WidgetEvents.FRAME_ENDED);
    });

    return {
      context,
      refresh,
    };
  },
  computed: {
    isDataEmpty() {
      const { cached_data } = this.config.get(WidgetConfig.WIDGET);
      return isNil(cached_data) || isEmpty(cached_data);
    },
  },
};
</script>
